
// export const apiCall = async (data, url, method = "GET", headers = {}) => {
//     try {
//       const options = {
//         method: method.toUpperCase(),
//         headers: {
//           "Content-Type": "application/json",
//           ...headers,
//         },
//         credentials: "include",
//       };
  
//       if (method !== "GET" && method !== "HEAD" && data) {
//         options.body = JSON.stringify(data);
//       }
//       const response = await fetch(url, options);
//       const result = await response.json();
//       return result;
//     } catch (error) {
//       console.error("❌ API Error:", error.message);
//       throw error;
//     }
//   };




// export const apiCall = async (data, url, method = "GET", headers = {}) => {
//     try {
//       const options = {
//         method: method.toUpperCase(),
//         headers: {
//           "Content-Type": "application/json",
//           ...headers,
//         },
//         credentials: "include",
//       };
  
//       if (method !== "GET" && method !== "HEAD" && data) {
//         options.body = JSON.stringify(data);
//       }
//       const response = await fetch(url, options);
//       const result = await response.json();
//       return result;
//     } catch (error) {
//       console.error("❌ API Error:", error.message);
//       throw error;
//     }
//   };
  

import Swal from "sweetalert2";

let activeRequests = 0;
let lastLoaderTime = 0; // store last loader open time

export const apiCall = async (data, url, method = "GET", headers = {}) => {
  try {
    activeRequests++;

    const now = Date.now();

    // ⏱ Show loader only if:
    // - first request
    // - and 10 sec passed since last loader
    if (
      activeRequests === 1 &&
      now - lastLoaderTime > 10000 // 10 sec
    ) {
      lastLoaderTime = now;

      Swal.fire({
        title: "Loading...",
        text: "Please wait",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    const options = {
      method: method.toUpperCase(),
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      credentials: "include",
    };

    if (method !== "GET" && method !== "HEAD" && data) {
      options.body = JSON.stringify(data);
    }

    const response = await fetch(url, options);
    const result = await response.json();

    return result;
  } catch (error) {
    console.error("❌ API Error:", error.message);
    throw error;
  } finally {
    activeRequests--;

    // close loader when all requests finish
    if (activeRequests === 0) {
      Swal.close();
    }
  }
};
